var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.ButtonClass,on:{"click":_vm.OnClick}},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageSource}})])
}
var staticRenderFns = []

export { render, staticRenderFns }